let initialState = {
  config: null,
  enumConfig: null,
  graphResponse: {},
  worksheetType: null,
  removeWorksheetResponse: null,
  availablePills: null,
  loader: false,
  loaderTrends: false,
  templateLoader: false,
  loaderConfig: false,
  loaderEnumConfig: false,
  graphConditionLoader: false,
  saveWorksheetResponse: null,
  template: null,
  worksheets: null,
  loadReportStatus: null,
  reportInfo: null,
  aggregateResponse: {},
  predefinedWidget: null,
  configurationData: null,
  preWidgetLoader: false,
  aggregateLoader: false,
  profileLoader: false,
  defaultPreFilters: [],
  graphConditionConfigurationData: null,
  ticketWidgetLoader: { widget_id: null, value: false },
  prolificFilters: null,
  graphConditions: null,
  profile_filter_list: null,
  profile_filter_loader: false,
  loaderBannerConfig: false,
  bannerConfig: null,
};
const apiCall = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CONFIG_DATA":
      return {
        ...state,
        config: action.payload,
      };
    case "SET_ENUM_CONFIG_DATA":
      return {
        ...state,
        enumConfig: action.payload,
      };
    case "SET_GRAPH_DATA":
      return {
        ...state,
        graphResponse: action.payload,
      };
    case "SET_AGGREGATE_DATA":
      return {
        ...state,
        aggregateResponse: action.payload,
      };
    case "SET_AVAILABLE_PILLS":
      return {
        ...state,
        availablePills: action.payload,
      };

    case "SET_GRAPH_LOADER":
      return {
        ...state,
        loader: action.payload,
      };
    case "SET_TEMPLATE_LOADER":
      return {
        ...state,
        templateLoader: action.payload,
      };
    case "SET_TRENDS_LOADER":
      return {
        ...state,
        loaderTrends: action.payload,
      };
    case "SET_CONFIG_LOADER":
      return {
        ...state,
        loaderConfig: action.payload,
      };
    case "SET_ENUM_CONFIG_LOADER":
      return {
        ...state,
        loaderEnumConfig: action.payload,
      };
    case "SET_GRAPH_CONDITION_LOADER":
      return {
        ...state,
        graphConditionLoader: action.payload,
      };
    case "SET_PREDEFINED_WIDGET_DATA":
      return {
        ...state,
        predefinedWidget: action.payload,
      };
    case "SET_CONFIGURATION_DATA":
      return {
        ...state,
        configurationData: action.payload,
      };
    case "SET_PRE_DEFAULT_FILTERS":
      return {
        ...state,
        defaultPreFilters: action.payload,
      };
    case "SET_PRE_WIDGET_LOADER":
      return {
        ...state,
        preWidgetLoader: action.payload,
      };
    case "SET_AGGREGATE_LOADER":
      return {
        ...state,
        aggregateLoader: action.payload,
      };
    case "SET_PROFILE_LOADER":
      return {
        ...state,
        profileLoader: action.payload,
      };
    case "SET_GRAPH_CONDITIONS_CONFIGURATION_DATA":
      return {
        ...state,
        graphConditionConfigurationData: action.payload,
      };
    case "SET_GRAPH_CONDITIONS":
      return {
        ...state,
        graphConditions: action.payload,
      };
    case "SET_PROLIFIC_FILTERS":
      return {
        ...state,
        prolificFilters: action.payload,
      };
    case "SET_TICKET_WIDGET_LOADER":
      return {
        ...state,
        ticketWidgetLoader: action.payload,
      };
    case "SET_PROFILE_FILTER_LIST":
      return {
        ...state,
        profile_filter_list: action.payload,
      };
    case "SET_PROFILE_FILTER_LOADER":
      return {
        ...state,
        profile_filter_loader: action.payload,
      };
    case "SET_BANNER_CONFIG_LOADER":
      return {
        ...state,
        loaderBannerConfig: action.value,
      };
    case "SET_BANNER_CONFIG_DATA":
      return {
        ...state,
        bannerConfig: action.configurationData,
      };
    default:
      return state;
  }
};

export default apiCall;
